import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-warehouse',
  templateUrl: './icon-warehouse.component.html',
  styleUrls: ['./icon-warehouse.component.scss']
})
export class IconWarehouseComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
